import { ErrorNames, UserFriendlyError } from '@pique/graphql';
import { type DocMode, Store } from '@toeverything/infra';

import { type FetchService, isBackendError } from '../../cloud';

export class ShareReaderStore extends Store {
  constructor(private readonly fetchService: FetchService) {
    super();
  }

  async loadShare(workspaceId: string, docId: string) {
    try {
      const [docResponse, workspaceResponse] = await Promise.all([
        this.fetchService.fetch(`/api/workspaces/${workspaceId}/docs/${docId}`),
        this.fetchService.fetch(`/api/workspaces/${workspaceId}/docs/${workspaceId}`),
      ]);

      const publishMode = docResponse.headers.get('publish-mode') as DocMode | null;
      const [docBinary, workspaceBinary] = await Promise.all([
        docResponse.arrayBuffer(),
        workspaceResponse.arrayBuffer(),
      ]);

      return {
        doc: new Uint8Array(docBinary),
        workspace: new Uint8Array(workspaceBinary),
        publishMode,
      };
    } catch (error) {
      console.error('[ShareReader] Error loading shared doc:', error);
      if (
        error instanceof Error &&
        isBackendError(error) &&
        UserFriendlyError.fromAnyError(error).name === ErrorNames.DOC_NOT_FOUND
      ) {
        return null;
      }
      throw error;
    }
  }
}
